import api from '@/services/api/api';

export const useTeachersCategory = () => {
  const teachersCategory = useQuery(
    ['teachersCategory'],
    async () => {
      const { data } = await api.teachers.getTeacherCategoies();
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await teachersCategory.suspense();
  });

  return {
    teachersCategory,
  };
};
